import { WebPaths } from '@griply/types';
import { useCallback, useState } from 'react';
import { ensureDesktopSignIn } from 'shared/services/local-storage';
import { getDesktopSignInBrowserUrl } from 'shared/utils/get-desktop-sign-in-urls';

export const useStartDesktopSignIn = () => {
  const [browserUrl, setBrowserUrl] = useState<string | null>(null);

  const start = useCallback(async (path: WebPaths = WebPaths.Login) => {
    const { challenge } = await ensureDesktopSignIn();
    const url = getDesktopSignInBrowserUrl(challenge, path);

    setBrowserUrl(url);
    window.electron?.openInBrowser?.(url);
  }, []);

  return { start, browserUrl };
};
